<template>
  <div class="org-examples-wrapper" @click="router.push({name: 'partnership'})">
    <div class="container">
      <section class="examples">
        <h2>{{ $t('org-care-title') }}</h2>
        <div class="org-logos" aria-label="Organization logos">
          <div class="org-left-column">
            <div class="org-logos-pair">
              <!-- <img class="org-logo logo-zdraveto-cross" src="/static/logo/zdravetohospitalcross.png" alt="Zdraveto Hospital" /> -->
              <img class="org-logo logo-zdraveto" src="/static/logo/zdravetohospital.png" alt="Zdraveto Hospital" />
            </div>
            <div class="example-card" @click.stop>
            <div class="thumb">
              <img
                src="/static/partnership/zdraveto-video-thumb.png"
                alt="Здравето"
              />
            </div>

            <div class="example-body">
              <div class="example-text">
                 {{ $t('zdraveto-example-text') }}
              </div>
            </div>

            <MainButton
              class="read-more"
              @click.stop="goToZdraveto"
            >
              {{ $t('zdraveto-learn-more-2') }}
            </MainButton>
          </div>
          </div>
          <div class="org-right-column">
            <img class="org-logo logo-transpress" src="/static/logo/transpress.png" alt="TRANSPRESS" />
            <div class="example-card">
            <div class="thumb transpress-thumb">
              <img
                src="/static/transpress/hero.png"
                alt="TRANSPRESS × Momfident"
              />
            </div>

            <div class="example-body">
              <div class="example-text">
                {{ $t('transpress-example-text') }}
              </div>
            </div>

            <MainButton
              class="read-more"
              @click.stop="router.push({ name: 'transpress-2026' })"
            >
              {{ $t('transpress-learn-more') }}
            </MainButton>
          </div>
        </div>
      </div>
      </section>
    </div>
  </div>
</template>

<script setup>
// import { ref } from 'vue';
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import router from "@/router";

// const isVideoPlaying = ref(false);
// const videoId = 'aWsV5InK380';
// const youtubeUrl = 'https://www.youtube.com/watch?v=aWsV5InK380';

function goToZdraveto() {
  router.push({ name: 'zdraveto-initiative-2026' });
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/fonts.scss";

.org-examples-wrapper {
  cursor: pointer;
  background-color: #fc678b; /* Pink background matching the reference */
  padding: 18px 0 50px; /* reduced bottom padding from 110px */
  /* make background full-width even when placed inside other layouts */
  margin: 0 calc(-1 * ((100vw - 100%) / 2));
  padding-left: calc((100vw - 100%) / 2);
  padding-right: calc((100vw - 100%) / 2);
}

.examples {
  text-align: center;
  font-family: 'Rubik', sans-serif;

  h2 {
    margin-top: 24px; /* moved text more down */
    margin-bottom: 10px;
    font-size: 26px; /* noticeably smaller */
    font-weight: 600; /* slightly bold */
    color: white; /* White heading on pink background */
  }

  .org-logos {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 34px;
    margin-top: 40px;
    margin-bottom: 20px;
  }

.org-left-column,
.org-right-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  width: 100%;
  max-width: 300px;
}

  .org-right-column {
    gap: 0px; 
  }

  
// .org-left-column .example-body{
//   margin-bottom:1.2em;
// }

  .org-logo {
    height: 90px; /* clearly bigger */
    width: auto;
    max-width: 400px;
    object-fit: contain;
  }

  .org-logos-pair {
    display: flex;
    align-items: center;
    gap: 0;
  }

  /* PNGs have built-in transparent padding; overlap slightly to look flush */
  .org-logos-pair .org-logo {
    display: block;
  }

  .logo-zdraveto-cross {
    height: 54px !important; /* slightly smaller */
    max-width: none !important;
  }

  .logo-zdraveto {
    height: 54px !important; /* slightly smaller */
    max-width: none !important;
    margin-left: -12px; /* keep flush after resize */
  }

  .logo-transpress {
    height: 66px; /* transpress logo slightly bigger */
    margin-top: 0px;
  }


.transpress-thumb {
  height: 145px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
  .example-card {
    background: #fdf0f3;
    border-radius: 26px; /* more rounded as in the reference */
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-left: 14px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 10px; /* slightly smaller card padding */
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover,
    &:focus-within {
      transform: translateY(-2px);
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.10);

      .thumb::after {
        opacity: 0.28; /* pink-tinted hover on image */
      }
    }
  }

  .thumb {
    border-radius: 18px;
    overflow: hidden;
    position: relative;

    iframe {
      width: 100%;
      height: 145px;
      border: 0;
      display: block;
    }

    .thumb__button {
      position: relative;
      width: 100%;
      border: none;
      background: transparent;
      padding: 0;
      margin: 0;
      cursor: pointer;
      display: block;
    }

    .thumb__play {
      position: absolute;
      inset: 0;
      display: grid;
      place-items: center;

      &::before {
        content: "";
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.82);
        box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
      }

      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-left: 14px solid rgba(55, 55, 88, 0.9);
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        transform: translateX(2px);
      }
    }

    .thumb__youtube-link {
      position: absolute;
      bottom: 10px;
      right: 10px;
      z-index: 3;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 26px;
      padding: 0 10px;
      border-radius: 999px;
      text-decoration: none;
      font-family: 'Rubik', sans-serif;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.2px;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.55);
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
      transition: transform 0.15s ease, background 0.15s ease;
    }

    .thumb__youtube-link:hover {
      background: rgba(0, 0, 0, 0.68);
      transform: translateY(-1px);
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: #fc678b;
      opacity: 0;
      transition: opacity 0.2s ease;
      pointer-events: none;
    }
    
    img {
      width: 100%;
      height: 145px;
      object-fit: cover;
      display: block;
    }
  }

  .example-body {
    padding: 8px 0 4px;
    font-size: 13px;
    min-height: 0;
    color: $color-purple;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .example-text {
    font-family: 'Rubik', sans-serif;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 700; /* Bolder text */
    text-align: left;
    color: #5a5583;
  }

  .read-more {
    margin-top: 6px;
    width: 100%;
    margin-bottom: 2px;
  }
}

@media (max-width: 768px) {
  .org-examples-wrapper {
    padding: 24px 0 70px;
  }

  .examples {
    h2 {
      font-size: 28px;
    }

    .org-logos {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-top: 30px;
      margin-bottom: 30px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .org-logo {
      height: 48px;
      max-width: 140px;
      flex-shrink: 0;
    }

    .org-logos-pair {
      width: 100%;
      justify-content: center;
      gap: 0;
    }

    .org-left-column {
      width: 100%;
      max-width: 300px;
      gap: 12px;
    }

    .org-logos-pair .org-logo {
      display: block;
    }

    .logo-zdraveto-cross {
      height: 44px !important;
      flex-shrink: 0;
    }

    .logo-zdraveto {
      height: 44px !important;
      flex-shrink: 0;
      margin-left: -8px; /* keep flush after resize */
    }

    .logo-transpress {
      height: 48px !important;
      max-width: 100% !important; /* wide logo — the 140px cap made it smaller than Zdraveto */
      margin-top: 0;
    }

    .thumb img,
    .thumb iframe {
      height: 130px;
    }

    .example-card {
      margin-left: 8px;
    }
  }
}
</style>
